const home2other = {
  state: {
    dateArr: []
  },
  mutations: {
    upDateArr: (state, payload) => {
      state.dateArr = payload
    }
  },
  actions: {
    upDateArr: ({commit}, payload) => {
      commit('upDateArr', payload)
    }
  }
}
export default home2other



// WEBPACK FOOTER //
// ./src/store/modules/home2other.js